export const flattenTranslations = (arr) => {
    let flatObject = {};
    for (const key in arr) {
        if (Object.prototype.hasOwnProperty.call(arr, key)) {
            const obj = arr[key];
            for (const sectionName in obj) {
                const section = obj[sectionName];
                for (const translationKey in section) {
                    const translation = section[translationKey];
                    if (Array.isArray(translation)) {
                        flatObject = Object.assign(Object.assign({}, flatObject), flattenTranslations(translation));
                    }
                    else {
                        flatObject = Object.assign(Object.assign({}, flatObject), { [`${sectionName}|${translationKey}`]: translation });
                    }
                }
            }
        }
    }
    return flatObject;
};
export const addParamToTranslation = (str, params) => {
    if (!params || Object.keys(params).length === 0)
        return str;
    const regex = new RegExp(`{{(${Object.keys(params).join('|')})}}`, 'g');
    return str.replace(regex, (_, key) => `${params[key]}` || '');
};
export const formatKey = (key) => key.replaceAll('-', '_');
export const processTranslationFiles = (files) => {
    try {
        return files.reduce((acc, item) => {
            var _a;
            if (!item.fields)
                return acc;
            const { fields: { translationsFields, key }, } = item;
            const formattedKey = formatKey(key);
            const data = translationsFields === null || translationsFields === void 0 ? void 0 : translationsFields.reduce((fieldsAcc, field) => {
                if (!field.fields)
                    return fieldsAcc;
                const { fields: { key, value }, } = field;
                return Object.assign(Object.assign({}, fieldsAcc), { [formatKey(key)]: value });
            }, {});
            return Object.assign(Object.assign({}, acc), { [formattedKey]: Object.assign(Object.assign({}, ((_a = acc[formattedKey]) !== null && _a !== void 0 ? _a : {})), data) });
        }, {});
    }
    catch (error) {
        console.error(error);
        return {};
    }
};
